import React from "react";
import { BreadCrumbItem } from "../../organisms/HeaderSection";
import Page from "../../organisms/Page";
import CardSection from "./CardSection";

const breadCrumbs: BreadCrumbItem[] = [
  {
    path: "/",
    label: "Inicio",
  },
  {
    path: "/servicios_productos",
    label: "Servicios y Productos",
    isActive: true,
  },
];

function ServiciosYProductos() {
  return (
    <Page
      title="Servicios y Productos"
      description="Visualización, creación y edición de servicios y productos."
      breadCrumbs={breadCrumbs}
    >
      <CardSection />
    </Page>
  );
}

export default ServiciosYProductos;
